'use client';

import { useId } from 'react';
import {
  RiFileList3Line,
  RiNotification3Line,
  RiShieldCheckLine,
  RiTimerLine,
} from '@remixicon/react';
import { useTranslations } from 'next-intl';

import { ProductSection, SectionHead } from '@/components/product-section';
import { hl } from '@/lib/rich-text';

/**
 * "İzi kalır" — kayıt, onay kuyruğu, bildirim, acil fren.
 *
 * Yalnız doğrulanmış iddialar (14 Eki 2026 ürün dökümü):
 *   · denetim kaydı Ayarlar → Güvenlik'te, süzgeçli, CSV dışa aktarımlı;
 *   · onay kuyruğu `/dashboard/agent/approvals`, sol menüde canlı rozet;
 *   · bildirim BUGÜN panel içi + e-posta (diğer kanallar kodda var, kapalı —
 *     açılmadan buraya yazılmaz);
 *   · tam otonomiyi yöneticiler kapatabiliyor; ödeme, API anahtarı, sahiplik
 *     devri, güvenlik ve otonomi ayarlarının kendisi hiçbir modda AI'a açık
 *     değil (`operator.ts` HUMAN_ONLY).
 * "Her işlem geri alınır" YAZILMADI: geri alma yalnız bazı işlemlerde var.
 */

const FACTS = [
  { key: 'log', Icon: RiFileList3Line },
  { key: 'queue', Icon: RiTimerLine },
  { key: 'notify', Icon: RiNotification3Line },
  { key: 'brake', Icon: RiShieldCheckLine },
] as const;

export function AutopilotTrust() {
  const t = useTranslations('featuresAutopilot.trust');
  const uid = useId();

  return (
    <ProductSection tone="white" labelledBy={`${uid}-title`}>
      <SectionHead
        id={`${uid}-title`}
        eyebrow={t('eyebrow')}
        title={t.rich('title', { hl })}
        lead={t('lead')}
      />

      <ul className="ps-facts">
        {FACTS.map(({ key, Icon }) => (
          <li key={key} className="ps-fact">
            <Icon className="ps-fact-icon" size={20} aria-hidden="true" />
            <p className="ps-fact-title">{t(`items.${key}.title`)}</p>
            <p className="ps-fact-text">{t(`items.${key}.text`)}</p>
          </li>
        ))}
      </ul>
    </ProductSection>
  );
}
